import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Precision Software Calibration",
    desc: "No generic files. Every map is developed for your exact engine, mileage, fuel grade and driving style — calibrated parameter by parameter.",
  },
  {
    number: "02",
    title: "Dyno-Tested Reliability",
    desc: "Every remap stays within factory safety tolerances while unlocking optimal thermal efficiency. Power you can use every day, not just on paper.",
  },
  {
    number: "03",
    title: "Eco & Fuel Economy Maps",
    desc: "Stronger low-end torque means higher gears and fewer revs. Economy-focused calibrations can cut fuel consumption by up to 12%.",
  },
];

const IMG =
  "https://images.unsplash.com/photo-1624085568108-36410cfe4d24?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const Manifesto = () => (
  <section className="relative py-24 sm:py-32 border-t border-[#1F232D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div
          className="relative overflow-hidden"
          style={{ clipPath: "polygon(0 3%, 97% 0, 100% 97%, 3% 100%)" }}
        >
          <img
            src={IMG}
            alt="Performance car at night"
            className="w-full h-[420px] sm:h-[520px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-asphalt/85 via-transparent to-asphalt/30" />
          <div className="absolute bottom-6 left-6">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-nitro">
              The Workshop
            </p>
            <p className="font-heading font-bold uppercase text-2xl text-neutral-100">
              Where maps are born
            </p>
          </div>
        </div>
        <div className="absolute -bottom-4 -right-4 w-28 h-28 border border-nitro/40 -z-10" />
      </motion.div>

      <div>
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-nitro mb-4 flex items-center gap-3">
          <span className="inline-block w-10 h-px bg-nitro" />
          The Manifesto
        </p>
        <h2 className="font-heading font-bold uppercase text-4xl sm:text-5xl leading-[0.95] text-neutral-100 mb-10">
          Power, engineered
          <span className="block text-outline">not guessed</span>
        </h2>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.number}
              data-testid={`manifesto-chapter-${c.number}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group flex gap-6 py-7 border-t border-[#1F232D] last:border-b hover:bg-panel/40 transition-colors duration-300 px-2 -mx-2"
            >
              <span className="font-heading font-extrabold text-4xl text-outline-red group-hover:text-nitro transition-colors duration-300 leading-none pt-1">
                {c.number}
              </span>
              <div>
                <h3 className="font-heading font-semibold uppercase tracking-wide text-xl text-neutral-100">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-neutral-400 leading-relaxed max-w-md">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
